import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseActivityEntity } from './activity-history/base-activity.entity';
import { MSmClientOpportunityEntity } from './m-sm-client-opportunity.entity';

@Index('idx_oa_opp_created', ['fkOpportunityId', 'createdDate'], {})
@Index('idx_oa_type', ['activityType'], {})
@Index('idx_oa_user', ['fkUserId'], {})
@Entity('opportunity_activity')
export class OpportunityActivityEntity extends BaseActivityEntity {
	@Column('int', { name: '_fk_opportunity__id', unsigned: true })
	public fkOpportunityId!: number;

	@ManyToOne(
		() => MSmClientOpportunityEntity,
		(opportunity) => opportunity.activities,
		{
			onDelete: 'CASCADE',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk_opportunity__id', referencedColumnName: 'id' }])
	public fkOpportunity!: MSmClientOpportunityEntity;
}
